import { BuildingGroupMultiValuedList } from '../../../BuildingGroup'
import { ListCell } from '../ListCell'

function TableBuildingGroupsListCell({
  List = BuildingGroupMultiValuedList,
  ...restProps
}) {
  return <ListCell {...restProps} List={List} />
}

export default TableBuildingGroupsListCell
